import React from 'react';
import Span from '../../Texts/Span/Span';
import Tooltip from '../../Tooltip/Tooltip';
import Icon from '../../Icon/Icon';
import * as S from './HeaderFormatter.styles';

export const HeaderFormatter = ({ column }) => (
  <S.Header align={column.align}>
    <Span variant='neutral' modifier='regular' type='4' weight='bold'>
      {column.text}
    </Span>
    {column.customHeader?.tooltip && (
      <S.IconWrapper>
        <Tooltip
          align='center'
          msg={
            <Span type='2' variant={'neutral'} modifier={'inverted'}>
              {column.customHeader.tooltip}
            </Span>
          }
        >
          <Icon
            name='info_circle_outline'
            cursor='pointer'
            width={16}
            height={16}
            variant='neutral'
            modifier='regular'
          />
        </Tooltip>
      </S.IconWrapper>
    )}
  </S.Header>
);
